import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { MouseEventHandler } from 'react';
import styles from "./CustomModal.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

interface CustomModalProps {
    open: boolean,
    handleClose: MouseEventHandler,
    children: React.ReactNode
}

export const CustomModal = ({open, handleClose, children}: CustomModalProps) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className={styles.modalContentContainer}>
                <div className={styles.closeButtonContainer}>
                    <div onClick={handleClose}>
                        <FontAwesomeIcon icon={faXmarkCircle} size="2x" className={styles.closeIcon}/>
                    </div>
                </div>
                {children}
            </Box>
        </Modal>
    )
}